import React from "react";
import styled from "styled-components";
const Container = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  border-radius: 3px;
  color: white;
  z-index: 999;
  height: 100%;
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
`

function ModalDrop({ children }) {
  return (
    <Container onClick={onclick}>
      <Wrapper>{children}</Wrapper>
    </Container>
  )
}

export default ModalDrop
